import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=3cdc9c5a&scoped=true"
import script from "./InvoicesList.vue?vue&type=script&lang=ts"
export * from "./InvoicesList.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=3cdc9c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc9c5a",
  null
  
)

export default component.exports